import React from 'react';
import { getColorFromPercentage } from '../utils/colorUtils';

const CategoryDetails = ({ category }) => {

  const isNA = category.average === 'N/A' || category.average === null || category.average === undefined;
  const displayScore = isNA 
    ? 0 
    : (typeof category.average === 'number' ? category.average : parseFloat(category.average) || 0);
  const percentage = displayScore ? (displayScore / 5) * 100 : 0;

  const getDetailScorePercentage = (score) => {
    if (score === 0 || score === 'N/A') return null;
    const numericScore = typeof score === 'number' ? score : parseFloat(score) || 0;
    return numericScore ? (numericScore / 5) * 100 : 0;
  };

  return (
    <div className="p-6 m-6 bg-white border border-gray-200 rounded-lg shadow-sm dark:border-gray-700 dark:bg-gray-800">
      <div className="flex justify-between items-center mb-5 pb-4 border-b-2 border-gray-200 dark:border-gray-600">
        <div className="text-lg font-semibold text-gray-900 dark:text-white">{category.name}</div>
        <div className="flex items-center gap-4">
          <div 
            className="text-3xl font-bold"
            style={{
              color: isNA ? '#95a5a6' : getColorFromPercentage(percentage)
            }}
          >
            {isNA ? 'N/A' : displayScore.toFixed(1)}
          </div>
          <div className="w-[200px] h-8 bg-gray-100 dark:bg-gray-600 rounded-full overflow-hidden shadow-inner">
            <div
              className="h-full rounded-full flex items-center justify-center text-white font-bold text-sm transition-all duration-1000"
              style={{
                width: `${percentage}%`,
                background: isNA
                  ? '#95a5a6'
                  : `linear-gradient(90deg, ${getColorFromPercentage(percentage)}, ${getColorFromPercentage(percentage)})`
              }}
            >
              {isNA ? 'N/A' : `${Math.round(percentage)}%`}
            </div>
          </div>
        </div>
      </div>

      <div className="mt-5">
        {category.details && category.details.map((detail, index) => {
          const detailPercentage = getDetailScorePercentage(detail.score);
          const isDetailNA = detailPercentage === null;
          
          return (
            <div key={index} className="mb-5 p-4 bg-gray-50 dark:bg-gray-700 rounded-lg border-l-4 border-gray-200 dark:border-gray-600 transition-all duration-300 hover:shadow-md hover:translate-x-1">
              <div className="flex justify-between items-start mb-2.5">
                <div className="font-semibold text-gray-900 dark:text-white flex-1 pr-4 leading-snug">{detail.requirement}</div>
                <div 
                  className="inline-flex items-center justify-center min-w-[45px] h-11 rounded-full font-bold text-lg text-white shrink-0"
                  style={{
                    background: isDetailNA ? '#95a5a6' : getColorFromPercentage(detailPercentage),
                    color: 'white'
                  }}
                >
                  {detail.score === 0 || detail.score === 'N/A' ? 'N/A' : (typeof detail.score === 'number' ? detail.score : parseFloat(detail.score) || 'N/A')}
                </div>
              </div>
              <div className="text-gray-700 dark:text-gray-300 leading-relaxed mt-2 text-[0.95rem]">{detail.reason}</div>
            </div>
          );
        })}
      </div>

      {category.categoryRecommendations && (
        <div className="mt-5 p-5 bg-blue-50 dark:bg-gray-700 border-l-4 border-blue-600 rounded-lg">
          <h4 className="text-lg font-semibold text-gray-900 dark:text-white mb-2.5">Recommendations</h4>
          <p className="text-gray-700 dark:text-gray-300 leading-relaxed">{category.categoryRecommendations}</p>
        </div>
      )}
    </div>
  );
};

export default CategoryDetails;

